import { api, guard, unwrap } from './client'

export const systemApi = {
  status: () => guard(async () => unwrap(await api.GET('/api/system'))),
  tools: () => guard(async () => unwrap(await api.GET('/api/tools'))),
  readiness: () => guard(async () => unwrap(await api.GET('/ready'))),
}
